import axios from 'axios';
import React, { useEffect } from 'react'
import BASEURL from '../../Config/global';
import { questionModal, successModal } from '../CustomModal';
import { Spinner } from 'react-bootstrap';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ImportDataFromRelax from './ImportDataFromRelax';
import { patchRequest } from '../../Util/requests';

const ScofaAppCards = ({ module }) => {

    const [data, setData] = React.useState([])
    const [isListPositionUpdated, setIsListPositionUpdated] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [showImportModal, setShowImportModal] = React.useState(false);



    useEffect(() => {
        document.title = 'Relax Scofa | Scofa App Modules';
        getCategoryData();
    }, [module]);

    const getCategoryData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${BASEURL}/api/${module}/scofa-flagged/`
            );
            const data = response?.data?.data;
            setData(data);
            setIsListPositionUpdated(false);
            console.log(data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const openModal = (moduleName) => {
        setShowImportModal(true);
    };

    const closeModal = () => {
        setShowImportModal(false);
    };

    const handleClick = (id) => {
        console.log("Remove Scofa flag clicked");
        questionModal.fire({
            title: `Do you want to Remove Scofa Track?`,
            confirmButtonText: `yes`,
        }).then((result) => {
            if (result.isConfirmed) {
                remvodScofaTrack(id);
            }
        });
    }

    const remvodScofaTrack = async (id) => {
        try {
            const url = `${BASEURL}/api/misc/scofa-flag/${module}/${id}/`;
            const payload = { "value": false };
            const response = await axios.patch(url, payload);
            if (!response.data.error) {
                getCategoryData();
                successModal.fire({
                    title: 'Scofa Track Removed Successfully',
                });
            }
            console.log(response)
        } catch (error) {
            console.error(error);
        }
    };

    const onSortEnd = (result) => {
        if (!result.destination) return;

        const oldIndex = result.source.index;
        const newIndex = result.destination.index;

        if (oldIndex === newIndex) return;

        const reordered = Array.from(data);
        const [moved] = reordered.splice(oldIndex, 1);
        reordered.splice(newIndex, 0, moved);
        setData(reordered);
        setIsListPositionUpdated(true);
    };

    const updateOrdering = async () => {
        questionModal.fire({
            title: `Do you want to Update Order?`,
            confirmButtonText: `yes`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await updateUpdateOrdering();
            }
        });
    };

    const updateUpdateOrdering = async () => {
        setLoading(true);
        try {
            const payload = data.map((item, index) => ({
                id: item.id,
                scofa_sequence: index + 1,
            }));

            const response = await patchRequest(`/api/${module}/scofa-flagged/`, payload);

            if (response?.data && !response.data.error) {
                successModal.fire({ title: 'Order updated successfully' });
                setIsListPositionUpdated(false);
                getCategoryData();
            }
        } catch (err) {
            console.error('order update error', err);
        } finally {
            setLoading(false);
        }
    }

    if (!loading && data.length === 0) {
        return <p className='text-center'>No Scofa Items Found</p>
    }

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{ height: "100px" }}>
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    }
    return (
        <>
            {/* show update button if order changed */}
            <div className="d-flex justify-content-end mb-3 gap-4">

                {isListPositionUpdated && (
                    <button className="customButton secondaryButton me-2"
                        onClick={updateOrdering}>
                        Update Order
                    </button>
                )}
                <button
                    className="customButton secondaryButton me-2"
                    onClick={() => openModal('articles')}
                >
                    Import {module === 'soundsmixture' ? 'Featured Mixes' : 'Articles'}
                </button>
            </div>

            <DragDropContext onDragEnd={onSortEnd}>
                <Droppable droppableId="scofa-cards-list">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {data.map((item, index) => (
                                <Draggable
                                    key={item.id || index}
                                    draggableId={`item-${item.id || index}`}
                                    index={index}
                                >
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={`customTable d-flex align-items-center gap-2 rounded mb-2 ${snapshot.isDragging ? 'dragging' : ''}`}
                                            style={{
                                                minHeight: "auto",
                                                background: "var(--background-color)",
                                                borderBottom: "1px solid #013D5F",
                                                padding: "10px 20px",
                                                ...provided.draggableProps.style
                                            }}
                                        >
                                            <div className="text-capitalize">
                                                <img src={item.image || item.banner} className='thumbnail' />
                                                {item.title}
                                            </div>

                                            <button onClick={() => handleClick(item.id)} className='button bg-transparent border-0 p-0 m-0 ms-auto'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={25} viewBox="0 0 39.87 39.87"><defs><style>{`.cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}`}</style></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_27" data-name="Layer 27"><path class="cls-1" d="M19.93,2A17.94,17.94,0,1,1,2,19.93,17.94,17.94,0,0,1,19.93,2m0-2A19.94,19.94,0,1,0,39.87,19.93,20,20,0,0,0,19.93,0Z" /><line class="cls-2" x1="11.03" y1="19.93" x2="28.84" y2="19.93" /></g></g></svg>
                                            </button>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            <ImportDataFromRelax
                inModal
                show={showImportModal}
                onHide={closeModal}
                module={module}
                initialSelectedData={data}
                getCategoryData={getCategoryData}
            />
        </>
    )
}

export default ScofaAppCards